export const GA2_TAB_SCENARIOS = {
  MATCHED: 1,
  ID_NOT_MATCHED: 2,
  TYPE_NOT_MATCHED: 3,
  ROGUE: 4,
  NONE: 5
};

export const defineGa2TabScenario = (du, su) => {
  const provisionInfo = su?.['provision-info'];
  const expectedSerialId = provisionInfo?.['expected-serial-id'] || '';
  const detectedSerialId = provisionInfo?.['detected-serial-id'] || '';
  const expectedNeType = provisionInfo?.['expected-ne-type'] || '';
  const detectedNeType = provisionInfo?.['detected-ne-type'] || '';
  let rogueSus = [];
  Object.entries(du).forEach(([key, value]) => {
    if (key.includes('rogue-su')) {
      rogueSus = [...rogueSus, ...value];
    }
  });
  
  if (
    expectedSerialId.length >= 20 &&
    detectedSerialId.length >= 20 &&
    expectedSerialId === detectedSerialId &&
    expectedNeType.length >= 10 &&
    detectedNeType.length >= 10 &&
    expectedNeType === detectedNeType
  ) {
    return GA2_TAB_SCENARIOS.MATCHED;
  } else if (expectedSerialId !== detectedSerialId) {
    return GA2_TAB_SCENARIOS.ID_NOT_MATCHED;
  } else if (expectedNeType !== detectedNeType) {
    return GA2_TAB_SCENARIOS.TYPE_NOT_MATCHED;
  } else if (expectedSerialId === '' && detectedSerialId === '' && rogueSus.length > 0) {
    return GA2_TAB_SCENARIOS.ROGUE;
  } else {
    return GA2_TAB_SCENARIOS.NONE;
  }
};

// matched - hasSerialId && hasSerialIdMatch && hasNEType && hasNETypeMatch
// serial id is not matched - hasSerialId && !hasSerialIdMatch
// NE type is not matched - hasNEType && !hasNETypeMatch
// rouge - hasRougeSU && !hasSerialId && !hasSerialIdMatch
//
